import React, { Fragment } from "react"
import { MdClose } from "react-icons/md"
import { useTranslation } from "react-i18next"

import { moment, scale } from "utils"
import PlLineTitle from "./PlLineTitle"
import PlSeparator from "./PlSeparator"
import PlSpecificationItems from "./PlSpecificationItems"
import { deliveryTypeLabels, productUnitsSymbol } from "constant"

const PlOrderDeletedPrintTemplate = (props) => {
  const {
    forPos,
    templateType,
    printData,
    printerWidth
  } = props

  const [t] = useTranslation()

  const {
    items,
    date,
    code,
    accountRole,
    tableNumber,
    deliveryType,
    serviceTypeName,
    customerFullName
  } = printData

  const i18n = useTranslation()[1]

  const dir = i18n.dir(i18n.language)

  const styles =
    templateType === "thermal"
      ? stylesThermal(printerWidth, dir)
      : stylesOthers(dir)

  const showTableNumber =
    !!tableNumber &&
    serviceTypeName === "restaurant"

  return (
    <Fragment>
      <div style={styles["container"]}>
        <div style={styles["header"]}>
          ({t("سفارش_کنسل_شد")})
        </div>

        {
          accountRole !== "access" &&
          <Fragment>
            <PlLineTitle
              templateType={templateType}
              title={t("اطلاعات_مشتری")}
            />

            <div style={styles["text"]}>
              {t("نام_و_نام_خانوادگی")}:{" "}
              <b style={styles["bold"]}>
                {customerFullName}
              </b>
            </div>
          </Fragment>
        }

        <PlLineTitle
          templateType={templateType}
          title={t("اطلاعات_سفارش")}
        />

        <div style={styles["text"]}>
          {t("تاریخ_سفارش")}:{" "}
          <b style={styles["bold"]}>
            {moment(date).format("jYYYY/jMM/jDD | HH:mm")}
          </b>
        </div>

        <div style={styles["text"]}>
          {t("نوع_تحویل")}:{" "}
          <b style={styles["bold"]}>
            {t(deliveryTypeLabels[deliveryType])}
          </b>
        </div>

        <div style={styles["text"]}>
          {t("سفارش")}:{" "}
          <b style={styles["bold"]}>
            {String(code)}
          </b>
        </div>

        {
          showTableNumber &&
          <div style={styles["text"]}>
            {t("میز")}:{" "}
            <b style={styles["bold"]}>
              {tableNumber}
            </b>
          </div>
        }

        <PlLineTitle
          templateType={templateType}
          title={t("آیتم_ها")}
        />

        <div style={styles["tableContainer"]}>
          <div style={styles["table"]}>
            <div style={styles["row"]}>
              <div style={styles["th_name"]}>
                <div style={styles["thText"]}>
                  {t("نام_کالا")}
                </div>
              </div>
              <div style={styles["th_qty"]}>
                <div style={styles["thText"]}>
                  {t("واحد")}
                </div>
              </div>
            </div>

            {items.map((item) =>
              <div key={item._id} style={styles["row"]}>
                <div style={styles["td_name"]}>
                  <div style={styles["tdText"]}>
                    {item.foodName}
                  </div>
                  {
                    !item.isSimple &&
                    <div style={styles["optionName"]}>
                      {item.option.name}
                    </div>
                  }
                  <PlSpecificationItems items={item.orderItemSpecifications.flatMap(item => item.specificationItems)}>
                    {(specificationItem, siIndex) =>
                      <div key={siIndex} style={styles["optionName"]}>
                        {specificationItem.name}

                        {
                          !specificationItem.isSelectable &&
                          <Fragment>
                            <MdClose />
                            {specificationItem.quantity * item.quantity}
                          </Fragment>
                        }
                      </div>
                    }
                  </PlSpecificationItems>
                </div>
                <div style={styles["td_qty"]}>
                  <div style={styles["tdTextNumber"]}>
                    {item.quantity}{productUnitsSymbol[item.unit]}
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>

      <PlSeparator
        forPos={forPos}
        templateType={templateType}
      />
    </Fragment>
  )
}


const stylesThermal = (printerWidth, dir = "ltr") => ({
  container: {
    marginRight: "8px",
    fontSize: scale("19px", printerWidth),
  },

  text: {

  },

  tableContainer: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  table: {
    width: "100%",
    border: `${scale("2px")} solid`
  },
  row: {
    display: "flex",
    flexDirection: "row"
  },
  th_name: {
    flex: 1.5,

    color: "white",
    backgroundColor: "black"
  },
  th_qty: {
    flex: "0.5",
    color: "white",
    backgroundColor: "black"
  },
  td_name: {
    flex: "1.5",
    border: `${scale("2px")} solid`,
    textAlign: dir === "rtl" ? "right" : "left"
  },
  td_qty: {
    flex: 0.5,
    border: `${scale("2px")} solid`,
    display: "flex",
    alignItems: "center",
    justifyContent: "center"
  },
  thText: {
    fontWeight: "bold",
    textAlign: "center",
  },
  tdText: {
  },
  optionName: {
  },
  bold: {
  },
  header: {
    textAlign: "center"
  },
  title: {

    textAlign: "center"
  },
  tdTextNumber: {
    textAlign: "center"
  }
})

const stylesOthers = (dir = "rtl") => ({
  container: {
    fontSize: "11px"
  },

  tableContainer: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center"
  },
  table: {
    width: "100%",
    border: "1px solid"
  },
  row: {
    display: "flex",
    flexDirection: "row"
  },
  th_name: {
    flex: "1.5",
    color: "white",
    padding: "1px",
    backgroundColor: "black"
  },
  th_qty: {
    flex: "0.5",
    padding: "1px",
    color: "white",
    backgroundColor: "black"
  },
  td_name: {
    flex: "1.5",
    padding: "1px",
    textAlign: dir === "rtl" ? "right" : "left"
  },
  td_qty: {
    flex: "0.5",
    padding: "1px",
    borderRight: "1px solid",
    display: "flex",
    alignItems: "center",
    justifyContent: "center"
  },
  thText: {
    fontWeight: "bold",
    textAlign: "center",
  },
  header: {
    textAlign: "center",
    fontWeight: "bold"
  },
  title: {
    textAlign: "center"
  },
  tdTextNumber: {
    textAlign: "center"
  },
  bold: {
    fontWeight: "bold"
  }
})

export default PlOrderDeletedPrintTemplate
